import React from "react";
import PropTypes from "prop-types";

/**
 * ClientAlreadyHaveAnAgent
 *
 * Client already have and agent screen. Collects if the user has an agent or not.
 *
 * @param {*} props
 * @returns
 */
const ClientAlreadyHaveAnAgent = (props) => {
  const {
    clientAlreadyHaveAnAgent,
    setClientAlreadyHaveAnAgent,
    nextScreen,
    prevScreen,
  } = props;
  const screenKey = "ClientAlreadyHaveAnAgent";

  const handleChange = (e) => {
    setClientAlreadyHaveAnAgent(e.target.value);
    setTimeout(() => {
      nextScreen({ key: screenKey });
    }, 200);
  };

  return (
    <div className="MessageAgentForm__screen" key="contact-info">
      <div className="MessageAgentForm__screen-heading">
        Have you already hired a real estate agent?
      </div>
      <div className="MessageAgentForm__screen-grid --alt">
        <label>
          <input
            name="alsoSelling"
            type="radio"
            value="yes"
            onClick={(e) => {
              handleChange(e);
            }}
            defaultChecked={clientAlreadyHaveAnAgent === "yes"}
          />
          <div>Yes</div>
        </label>
        <label>
          <input
            name="alsoSelling"
            type="radio"
            value="no"
            onClick={(e) => {
              handleChange(e);
            }}
            defaultChecked={clientAlreadyHaveAnAgent === "no"}
          />
          <div>No</div>
        </label>
      </div>
      <div className="MessageAgentForm__screen-controls">
        <button
          className="--alt"
          type="button"
          onClick={() => {
            prevScreen({ key: screenKey });
          }}
        >
          Back
        </button>
      </div>
    </div>
  );
};

ClientAlreadyHaveAnAgent.propTypes = {
  clientAlreadyHaveAnAgent: PropTypes.string,
  setClientAlreadyHaveAnAgent: PropTypes.func.isRequired,
  nextScreen: PropTypes.func.isRequired,
  prevScreen: PropTypes.func.isRequired,
};

ClientAlreadyHaveAnAgent.defaultProps = {
  clientAlreadyHaveAnAgent: undefined,
  setClientAlreadyHaveAnAgent: () => {},
  nextScreen: () => {},
  prevScreen: () => {},
};

export default ClientAlreadyHaveAnAgent;
